import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'fr_CH',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '2da7f438-a947-4edf-a54c-c0ed2e6a32f5',
  ''
);
